import { useEffect, useRef } from "react";
import { fabric } from "fabric";
import styles from "./canvasStyles.module.css";

const LoadCanvasPages = (props) => {
  const {
    pageCanvas,
    thumbnails,
    divId,
    pagesArray,
    generateThumbnail,
    // setThumbnailsUrl,
    renderCanvas,
    setRenderCanvas,
  } = props;

  useEffect(() => {
    pageCanvas.current.forEach((element) => {
      element.renderAll();
    });
    if (pagesArray.length > 0 && renderCanvas) {
      setRenderCanvas(false);
      renderPages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagesArray]);

  const generateThumbnailImages = async (canvas, lastPage) => {
    const workareaObj = canvas
      ?.getObjects()
      ?.filter((o) => o?.custype === "workarea")[0];
    const multiplierScale =
      1 /
      ((workareaObj.getScaledWidth() * workareaObj.getScaledHeight()) /
        1_000_000);
    const cropOptions = {
      multiplier:
        multiplierScale < 1 ? 1 : multiplierScale < 4 ? 4 : multiplierScale,
      format: "webp",
      quality: 0.7,
    };
    const thumbnailDataUrl = await canvas.toDataURL(cropOptions);

    const res = await fetch(thumbnailDataUrl);
    const blob = await res.blob();
    // if (lastPage && blob) {
    //   setThumbnailsUrl([...thumbnails.current, blob]);
    // }
    thumbnails.current.push(blob);
  };

  const renderPages = async () => {
    const parentBody = document.getElementById(divId);
    const asyncRender = (i) => {
      return new Promise((resolve) => {
        const pagesContainer = document.getElementById("pages-container");
        const canvasPages = pagesContainer.querySelectorAll("canvas");
        let pageScale = 1,
          page;
        if (canvasPages.length < pagesArray.length) {
          page = document.createElement("canvas");
          page.setAttribute("id", `page${i + 1}`);
          pagesContainer?.appendChild(page);
        }
        pageCanvas.current[i] = new fabric.StaticCanvas(`page${i + 1}`);
        pageCanvas.current[i].setWidth(pagesArray[i].width * pageScale);
        pageCanvas.current[i].setHeight(pagesArray[i].height * pageScale);
        pageCanvas.current[i].loadFromJSON(
          JSON.stringify(pagesArray[i]),
          async () => {
            let objinworkarea = [],
              objoutofworkarea = [],
              zoomCalcval;
            const canvasObjects = pageCanvas.current[i].getObjects();
            let workarea = canvasObjects.filter(
              (o) => o.custype === "workarea"
            )[0];
            if (typeof workarea !== "object") {
              return null;
            }
            if (parentBody && workarea.custype === "workarea") {
              if (workarea.width > workarea.height) {
                pageScale = parentBody.offsetWidth / workarea.width;
                if (parentBody.offsetHeight < workarea.height * pageScale) {
                  pageScale = parentBody.offsetHeight / workarea.height;
                }
              } else {
                pageScale = parentBody.offsetHeight / workarea.height;
              }
              pageCanvas.current[i].setWidth(workarea.width * pageScale * 0.85);
              pageCanvas.current[i].setHeight(
                workarea.height * pageScale * 0.85
              );
            }
            zoomCalcval =
              pageCanvas.current[i]?.getWidth() / workarea.getScaledWidth();
            if (
              zoomCalcval * workarea.getScaledHeight() >
              pageCanvas.current[i].getHeight()
            ) {
              zoomCalcval =
                pageCanvas.current[i]?.getHeight() / workarea.getScaledHeight();
            }
            pageCanvas.current[i].zoomToPoint(
              new fabric.Point(
                pageCanvas.current[i].getWidth() / 2,
                pageCanvas.current[i].getHeight() / 2
              ),
              Number(zoomCalcval)
            );
            pageCanvas.current[i]?.getObjects().filter((o) => {
              if (
                o.top <= workarea.top - 100 ||
                o.left <= workarea.left - 100 ||
                o.top + o.getScaledHeight() >=
                  workarea.top + workarea.getScaledHeight() + 100 ||
                o.left + o.getScaledWidth() >=
                  workarea.left + workarea.getScaledWidth() + 100
              ) {
                if (
                  o?.custype === "workarea" ||
                  o?.custype === "hashcode_group"
                ) {
                  objinworkarea.push(o);
                } else {
                  o.id !== "pixel-line" && objoutofworkarea.push(o);
                }
              } else {
                o.id !== "pixel-line" && objinworkarea.push(o);
              }
            });
            const group = new fabric.Group(objinworkarea);
            objinworkarea.map((o) => pageCanvas.current[i]?.remove(o));
            pageCanvas.current[i]?.add(group);
            group.viewportCenter();
            const items = group.getObjects();
            group.destroy();
            pageCanvas.current[i]?.remove(group);
            items.forEach((item) => {
              item.set("dirty", true);
            });
            pageCanvas.current[i]?.add.apply(pageCanvas.current[i], items);
            pageCanvas.current[i].getObjects().forEach((item) => {
              if (item.custype === "workarea") {
                workarea = item;
              }
              if (item.custype === "backgroundImg") {
                item.set({
                  scaleX: workarea.getScaledWidth() / item.width,
                  scaleY: workarea.getScaledHeight() / item.height,
                  top: workarea.top,
                  left: workarea.left,
                });
              }
            });
            objoutofworkarea.forEach((o) => o.bringForward());
            workarea.sendToBack();
            pageCanvas.current[i].set({
              backgroundColor: "#cccccc00",
            });
            pageCanvas.current[i].renderAll();
            if (generateThumbnail) {
              await generateThumbnailImages(
                pageCanvas.current[i],
                i === pagesArray.length - 1
              );
            }
            resolve();
          }
        );
      });
    };

    for (let i = 0; i < pagesArray.length; i++) {
      await asyncRender(i);
    }
  };
  return (
    <div
      id="pages-container"
      className={styles.StaticCanvasPagesContainer}
    ></div>
  );
};

export default LoadCanvasPages;
